export const DATA_NOTI_EMAIL: App.OptionsFnc = (t) => [
  { label: t('basic_setting.notify'), value: '1' },
  { label: t('basic_setting.not_notify'), value: '0' },
];

export const SUGGESTION_CONDITION: App.OptionsFnc = (t) => [
  {
    label: t('basic_setting.do_not_display_suggestions'),
    value: 'NOT_DISPLAY',
  },
  { label: t('basic_setting.if_the_price_is_low'), value: 'PRICE_LOW' },
  { label: t('basic_setting.fast_delivery'), value: 'FAST_DELIVERY' },
  {
    label: t('basic_setting.both_price_and_delivery'),
    value: 'PRICE_LOW_AND_FAST_DELIVERY',
  },
];

export const PDF_VERSION: App.OptionsFnc = (t) => [
  { label: t('basic_setting.landscape_version'), value: '1' },
  { label: t('basic_setting.portrait_version'), value: '0' },
];

export enum RoundingPositionType {
  ROUNDING_POSITION = 'ROUNDING_POSITION',
  ROUNDING_POSITION_SECONDARY = 'ROUNDING_POSITION_SECONDARY',
}

export const ROUNDING_POSITION: App.OptionsFnc = (t) => [
  {
    label: t('basic_setting.unified_rounding_position'),
    value: RoundingPositionType.ROUNDING_POSITION,
  },
];

export const ROUNDING_POSITION_SECONDARY: App.OptionsFnc = (t) => [
  {
    label: t('basic_setting.individual_rounding_settings'),
    value: RoundingPositionType.ROUNDING_POSITION_SECONDARY,
  },
];

export const OPTIONS_HASU_TANI: App.OptionsFnc = (t) => [
  { label: t('basic_setting.10th_place'), value: -2 },
  { label: t('basic_setting.1st_place'), value: -1 },
  {
    label: t('basic_setting.first_digit'),
    value: 0,
  },
  {
    label: t('basic_setting.2nd_digit'),
    value: 1,
  },
  { label: t('basic_setting.3rd_digit'), value: 2 },
  {
    label: t('basic_setting.4th_digit'),
    value: 3,
  },
  {
    label: t('basic_setting.5th_digit'),
    value: 4,
  },
];

export const OPTIONS_MARUME_HOHO: App.OptionsFnc = (t) => [
  {
    label: t('basic_setting.truncation'),
    value: '1',
  },
  { label: t('basic_setting.round_up'), value: '2' },
  { label: t('basic_setting.rounding'), value: '3' },
];

export const DATA_IMAGE_DISPLAY_SETTING: App.OptionsFnc = (t) => [
  { label: t('basic_setting.show'), value: '1' },
  { label: t('basic_setting.hide'), value: '0' },
];

export const DATA_IMAGE_NUM_OF_LINE: App.OptionsFnc = (t) => [
  { label: t('basic_setting.two_row'), value: '2' },
  { label: t('basic_setting.one_row'), value: '1' },
];
